<template>
  <v-layout column _now-it-works>
    <!--How it works-->
    <v-flex class="app-bg-sand">
      <v-container grid-list-xl>
        <v-layout row wrap>
          <v-flex xs12>
            <app-btn-toggle-role
              @getnanny_clickOperation="redirectpage($event)"
              v-model="selectedRole"
            />
          </v-flex>

          <!--CARDS-->
          <v-flex class="py-5">
            <v-layout column v-if="isMobile()">
              <v-flex
                v-for="(card, i) in cards"
                :key="`c_${card.id}`"
                xs12
                sm6
              >
                <app-card-page-item
                  :item="card"
                  :reverse="i % 2 === 0"
                  row
                  class="_now-it-works--card-row"
                  :class="{ 'pull-right': i % 2 !== 0 }"
                >
                  <template #icon="{ item }">
                    <app-svg-icon
                      :name="`brand/${item.svg_name}`"
                      :color="`var(--${item.svg_color})`"
                    />
                  </template>
                  <template #text="{ item }">
                    <h3 class="mb-3">{{ item.name }}</h3>
                    <div v-html="item.description" class="text-small"></div>
                  </template>
                </app-card-page-item>
              </v-flex>
            </v-layout>

            <v-layout v-else>
              <v-layout column v-if="selectedRole === 'parent'">
                <img
                  class="image-how-it-work"
                  src="@/assets/img/how-it-work-nanny.png"
                  alt="How it works for parents - Step by step guide"
                />
              </v-layout>
              <v-layout column v-else>
                <img
                  class="image-how-it-work"
                  src="@/assets/img/how-it-work-parent.png"
                  alt="How it works for nannies - Step by step guide"
                />
              </v-layout>
            </v-layout>
          </v-flex>

          <!--Why NannyGrannies-->
          <v-flex v-if="selectedRole === 'parent'">
            <v-container>
              <v-layout row wrap>
                <v-flex tag="h2" class="text-xs-center xs12 mt-5"
                  >Why NannyGranny</v-flex
                >
                <v-flex
                  v-for="card in benefits"
                  :key="`c_${card.id}`"
                  xs12
                  sm4
                >
                  <app-card-page-item
                    :item="card"
                    class="_now-it-works--card-why"
                  >
                    <template #text="{ item }">
                      <app-svg-icon
                        :name="`brand/${item.svg_name}`"
                        :color="`var(--${item.svg_color})`"
                      />
                      <h3 class="mb-3">{{ item.name }}</h3>
                      <div v-html="item.description" class="text-small"></div>
                    </template>
                  </app-card-page-item>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>

          <!--Signup-->
          <v-flex v-if="selectedRole === 'nanny'" class="">
            <v-layout column text-xs-center>
              <v-flex v-if="!$auth || !$auth.check()">
                <v-btn
                  to="/signup?role=nanny"
                  class="primary v-btn--default elevation-0 mt-5"
                >
                  Register now
                </v-btn>
              </v-flex>
              <v-flex class="text-small">
                <span class="text--charcoal">Still have questions? Try our</span>
                <router-link to="/faqs" class="text-small">FAQs</router-link>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>

    <!--Choose a plan-->
    <v-flex v-if="selectedRole === 'parent'" class="app-bg-sand--half">
      <v-container grid-list-xl w--max--800>
        <v-layout column text-xs-center>
          <v-flex tag="h2">Choose a plan</v-flex>
          <v-flex>
            <AppBtnTogglePlanReg hide-description />
          </v-flex>
          <v-flex class="text-small">
            <span class="text--charcoal">Still have questions? Try our</span>
            <router-link to="/faqs" class="text-small">FAQs</router-link>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>

    <!--Story-->
    <v-flex
      v-if="selectedRole === 'parent'"
      class="_now-it-works--story-section"
    >
      <app-card-story
        :src-image="story && story.image ? getUrl(story.image.path) : ''"
      >
        <h1 class="mb-4">{{ story.name }}</h1>
        <div v-html="story.description" class="mb-4"></div>
        <v-btn
          v-if="selectedRole === 'parent'"
          to="/about-us"
          class="primary elevation-0 ma-0 v-btn--default"
        >
          Read more
        </v-btn>
        <v-btn
          v-if="selectedRole === 'nanny' && (!$auth || !$auth.check())"
          to="/signup?role=nanny"
          class="primary elevation-0 ma-0 v-btn--default"
        >
          Join today
        </v-btn>
      </app-card-story>
    </v-flex>

    <!--ClubHouse-->
    <v-flex>
      <v-container grid-list-xl>
        <v-layout row wrap>
          <v-flex tag="h2" class="xs12 text-xs-center">ClubHouse</v-flex>
          <v-flex
            v-for="(item, i) in latestArticle"
            :class="{ 'hidden-sm-and-down': i === 2 }"
            :key="'art_' + item.id"
            xs12
            sm6
            md4
          >
            <app-card-article
              :item="item"
              :hide-actions="!$auth || !$auth.check()"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import AppBtnToggleRole from "../../../components/app-buttons/app-btn-toggle-role";
import AppBtnTogglePlanReg from "../../../components/app-buttons/app-btn-toggle-plan";
import AppCardArticle from "../../../components/app-card/app-card-article";
import AppCardPageItem from "../../../components/app-card/app-card-page-item";
import AppCardStory from "../../../components/app-card/app-card-story";
import { IMAGE_BASE_URL } from "@/config/constants";

export default {
  name: "how-it-works",
  components: {
    AppCardStory,
    AppCardPageItem,
    AppCardArticle,
    AppBtnTogglePlanReg,
    AppBtnToggleRole,
  },
  data() {
    let role = "parent";
    if (typeof window !== "undefined" && this.$auth && this.$auth.user()) {
      role = this.$auth.user().role || "parent";
    }
    return {
      selectedRole: role,
    };
  },
  computed: {
    latestArticle() {
      return this.$store.getters["articles/collection"];
    },
    content() {
      return this.$store.getters["page/content"]("how-it-works") || [];
    },
    cards() {
      return this.content.filter(
        (item) => item.slug === `${this.selectedRole}_card`
      );
    },
    benefits() {
      return this.content.filter((item) => item.slug === `why_nannygrannies_card`);
    },
    story() {
      return (
        this.content.filter(
          (item) => item.slug === `${this.selectedRole}_story`
        )[0] || {}
      );
    },
  },
  created() {
    if (this.$store) {
      this.$store.dispatch("articles/ARTICLES_GET", { per_page: 3 });
    }
  },
  
  // mounted() {
  //   if (typeof document !== "undefined") {
  //     document.title =
  //       "Discover Reliable Nannies – Get the Best Care for Your Child";

  //     const updateMetaTag = (name, content) => {
  //       let metaTag = document.querySelector(`meta[name="${name}"]`);
  //       if (metaTag) {
  //         metaTag.setAttribute("content", content);
  //       } else {
  //         metaTag = document.createElement("meta");
  //         metaTag.setAttribute("name", name);
  //         metaTag.setAttribute("content", content);
  //         document.head.appendChild(metaTag);
  //       }
  //     };

  //     updateMetaTag(
  //       "description",
  //       "Our experienced professionals provide loving, reliable childcare tailored to your family's needs. Find a trusted caregiver who perfectly fits your requirements today."
  //     );
  //     updateMetaTag(
  //       "title",
  //       "Discover Reliable Nannies – Get the Best Care for Your Child"
  //     );
  //   }
  // },

  metaInfo() {
    return {
      title: 'Discover Reliable Nannies – Get the Best Care for Your Child',
      meta: [
        {
          name: 'description',
          content: 'Our experienced professionals provide loving, reliable childcare tailored to your family\'s needs. Find a trusted caregiver who perfectly fits your requirements today.'
        }
      ]
    }
  },
  methods: {
    redirectpage(getevent) {
      if (getevent == 1) {
        this.$router.push("/how-it-works/become-a-nanny");
      }
    },
    getUrl(path) {
      return IMAGE_BASE_URL + path;
    },
    isMobile() {
      if (
        typeof navigator !== "undefined" &&
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.w--max--800
  max-width 900px !important
._now-it-works
  &--card-why
    @media (min-width 600px)
      .svg-icon
        width 32px
        height 32px
        margin-bottom 15px
      @media (min-width 600px)
        width 42px
        height 42px
        margin-bottom 15px

  &--card-row
    @media (min-width 600px)
      max-width 50% !important
      &.pull-right
        margin-left auto !important
      .svg-icon
        width 64px
        height 64px
      @media (min-width 600px)
        width 110px
        height 85px

  .app-bg-sand--half
    position relative
    &:before
      content ''
      top 0
      left 0
      width 100%
      display block
      position absolute
      background-color var(--sand)
      z-index 1
    .container
      position relative
      z-index 5
</style>



// WEBPACK FOOTER //
// src/views/content/how-it-works/index.vue